import axios from "axios";


export const customerData = async () => {
    return await axios.get(`${process.env.REACT_APP_HOST}/customersadd`);
};

export const executiveData = async () => {
    return await axios.get(`${process.env.REACT_APP_HOST}/executives`);
};


export const ordersData = async () => {
    return await axios.get(`${process.env.REACT_APP_HOST}/orders`);
};
export const productData = async () => {
    return await axios.get(`${process.env.REACT_APP_HOST}/products`);
};
export const purchaseData = async () => {
    return await axios.get(`${process.env.REACT_APP_HOST}/invoicesnew`);
};
export const incentiveData = async () => {
    return await axios.get(`${process.env.REACT_APP_HOST}/incentives`);
};


export const companyData = async () => {
    return await axios.get(`${process.env.REACT_APP_HOST}/companies`);
};